jQuery(document).ready(function ($) {
  var openClass = 'is-open';

  $(document).on('click', '.read_more_stack--single .js-read-more-single-toggle', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var $item = $btn.closest('.read_more_stack__item');
    var $panel = $item.find('.js-read-more-single-panel');
    var $label = $btn.find('.js-read-more-single-label');

    if (!$panel.length) {
      return;
    }

    var moreText = $btn.data('labelMore') || 'Read More';
    var lessText = $btn.data('labelLess') || 'Read Less';

    var expanded = $btn.attr('aria-expanded') === 'true';

    if (expanded) {
      $btn.removeClass(openClass).attr('aria-expanded', 'false');
      $label.text(moreText);
      $panel.attr('aria-hidden', 'true').stop(true, true).slideUp(200);
    } else {
      $btn.addClass(openClass).attr('aria-expanded', 'true');
      $label.text(lessText);
      $panel.attr('aria-hidden', 'false').stop(true, true).slideDown(200);
    }
  });
});
